import { InfoArrayHome1, InfoArrayHome2, InfoArrayHome3 } from './InfoComponents';
import imgControl from "../../Assets/Images/controle-de-qualite.png";
import imgTirelire from "../../Assets/Images/tirelire.png";
import imgCasser from "../../Assets/Images/casser.png";
import schemaTeachr from "../../Assets/Images/SchemaFacturation/SchemaTeachr.png";
import GuitareImage from "../../Assets/Images/guitare-illustration.png";
import { getActiveBrandConfig } from '../../config/environment.config';

// Données communes pour les tableaux de comparaison
export const commonComparisonData = [
  {
    label: "Vos cours sont déclarés",
    system: 1,
    aici: 1,
  },
  {
    label: "Montant de cotisations sociales sur vos cours",
    system: 3,
    aici: 2,
  },
  {
    label: "Remboursement de 50% instantané",
    infoType: 1,
    system: 0,
    aici: 1,
  },
  {
    label: "Avoir la main sur vos paiements",
    infoType: 2,
    system: 0,
    aici: 1,
  },
  {
    label: "Vous ne gérez ni l'administratif ni la facturation",
    infoType: 3,
    system: 0,
    aici: 1,
  },
];

// Données communes pour les avantages
export const commonAdvantages = [
  {
    icon: imgTirelire,
    alt: "Réduction des cotisations",
    title: "Remboursement immédiat :",
    description: "Vos élèves n'auront plus qu'à débourser seulement 50% du montant que vous leur facturez ! C'est une aubaine pour leur pouvoir d'achat, et ça leur permettra de prendre plus de cours qu'avant !"
  },
  {
    icon: imgCasser,
    alt: "Gestion simplifiée",
    title: "Gestion simplifiée :",
    description: "Grâce à l'adresse mail de votre élève, envoyez-lui facilement un formulaire d'inscription. Une fois complété, votre élève n'aura plus rien à faire. Renseignez vos cours en quelques secondes et laissez-nous gérer l'administratif. Concentrez-vous sur l'essentiel : vos cours !"
  },
  {
    icon: imgControl,
    alt: "Contrôle Total",
    title: "Contrôle Total :",
    description: "Vous n'aurez plus à recevoir vos paiements en vrac de la part de chacun de vos élèves. Centralisez vos virements, et ayez la main sur les prélèvements de tous vos élèves ! Nous nous occupons également de l'édition de l'envoi de vos factures, ainsi que les attestations annuelles à fournir à vos élèves."
  }
];

// Configuration spécifique pour chaque page
export const adsPageConfigs = {
  aeCi: {
    metaDescription: "Auto-etrepreneur crédit d'impôt",
    tiktokPixelId: "CPG2A9JC77U57258I150",
    facebookPixelId: "1186395682777492",
    heroTitle: "Professeur particulier ?",
    heroSubtitle: "Découvrez le crédit d'impôt instantané !",
    heroDescription: "Comme la plupart des professeurs particuliers, vous n'avez pas encore activé ce mode de paiement pour vos cours. Quel dommage ! Vous pourriez permettre à vos élèves de ne payer que la moitié de vos factures ! On vous explique tout ci-dessous.",
    heroButtonText: "JE M'INSCRIS !",
    heroButtonLink: `/${getActiveBrandConfig()}/register`,
    leftColumnTitle: "Auto-entrepreneur avec crédit d'impôt",
    rightColumnTitle: "Avec notre service, l'avance immédiate pour les professeurs indépendants",
    bottomRowData: {
      left: "Montant net perçu pour un cours payé 25€/h par votre élève, avec / sans crédit d'impôt",
      middle: "50€ payés, remboursé 25€ l'année d'après / Rémunéré 39.6€ net (21,1%) ou 44,7€",
      right: "Coût élève : 25€ après crédit d'impôt instantané. Rémunération 34,51€ net (21,1%) ou 39,13€ (10,55%), déduit des frais de Teach'r de 12,5%"
    },
    whyChooseTitle: "Pourquoi choisir Teach'r ?",
    whyChooseDescription: "Teach'r est l'un des rares services vous offrant un accès à l'Avance Immédiate pour vos cours sans aucune démarche administrative à réaliser. Nous vous permettons d'accéder à l'Avance Immédiate dans des délais imbattables, tout en proposant les frais de gestion les plus bas du marché !",
    advantagesTitle: "Les Avantages de Teach'r :",
    billingTitle: "Découvrez comment fonctionne la facturation avec Teach'r :",
    billingDescription: "Simplifiez votre gestion administrative avec Teach'r. De la génération et l'envoi des factures à la transmission des paiements, nous prenons tout en charge. Vous n'avez plus à vous soucier de rien. Découvrez comment Teach'r peut transformer votre quotidien en comparant votre situation actuelle avec notre offre.",
    currentSituationImage: "../../Assets/Images/SchemaFacturation/SchemaAeCi.png",
    teachrImage: schemaTeachr
  },
  aeNoCi: {
    metaDescription: "Auto-etrepreneur crédit d'impôt",
    tiktokPixelId: "CPG29N3C77U57258I130",
    facebookPixelId: "1637785340315682",
    heroTitle: "Professeur particulier ?",
    heroSubtitle: "Qu'attendez-vous pour utiliser l'Avance Immédiate ?",
    heroDescription: "Grâce à Teach'r, permettez dès demain à vos élèves de ne payer que la moitié de vos factures !",
    heroButtonText: "JE M'INSCRIS !",
    heroButtonLink: `/${getActiveBrandConfig()}/register`,
    leftColumnTitle: "Auto-entrepreneur sans crédit d'impôt",
    rightColumnTitle: "Avec notre service, l'avance immédiate pour les professeurs indépendants",
    bottomRowData: {
      left: "Montant net perçu pour un cours payé 25€/h par votre élève, avec / sans crédit d'impôt",
      middle: "25€ payés par votre élève, 19,7€ net (21,1%) ou 22,35€ net (10,55%)",
      right: "Coût élève : 25€ après crédit d'impôt instantané. Rémunération 34,51€ net (21,1%) ou 39,13€ (10,55%), déduit des frais de Teach'r de 12,5%"
    },
    whyChooseTitle: "Pourquoi choisir Teach'r ?",
    whyChooseDescription: "Teach'r est l'un des rares services vous offrant un accès à l'Avance Immédiate pour vos cours sans aucune démarche administrative à réaliser. Nous vous permettons d'accéder à l'Avance Immédiate dans des délais imbattables, tout en proposant les frais de gestion les plus bas du marché !",
    advantagesTitle: "Les Avantages de Teach'r :",
    billingTitle: "Découvrez comment fonctionne la facturation avec Teach'r :",
    billingDescription: "Simplifiez votre gestion administrative avec Teach'r. De la création de votre déclaration SAP à la transmission des paiements, en passant par la génération et l'envoi des factures, nous prenons tout en charge. Vous n'avez plus à vous soucier de rien. Découvrez comment Teach'r peut transformer votre quotidien en comparant votre situation actuelle avec notre offre.",
    currentSituationImage: "../../Assets/Images/SchemaFacturation/SchemaAeNoCi.png",
    teachrImage: schemaTeachr
  },
  cesu: {
    metaDescription: "Auto-etrepreneur crédit d'impôt",
    tiktokPixelId: "CPG1LFRC77UAVM146LH0",
    facebookPixelId: "1493660521500836",
    heroTitle: "Professeur particulier ?",
    heroSubtitle: "Passez à l'Avance Immédiate : simplifiez vos démarches et oubliez le CESU !",
    heroDescription: "Savez-vous que 45% de votre salaire est versé à l'URSSAF en cotisations sociales et patronales ? Reprenez le contrôle de vos finances en devenant indépendant et ne cotisez plus qu'à hauteur de 22% !",
    heroButtonText: "JE M'INSCRIS !",
    heroButtonLink: `/${getActiveBrandConfig()}/register`,
    leftColumnTitle: "Avec le CESU",
    rightColumnTitle: "Avec notre service, l'avance immédiate pour les professeurs indépendants",
    bottomRowData: {
      left: "Montant net perçu pour un cours payé 25€/h par votre élève, avec / sans crédit d'impôt",
      middle: "50€ payés, remboursé 25€ l'année d'après / Rémunéré 28€ net",
      right: "Coût élève : 25€ après crédit d'impôt instantané. Rémunération 34,51€ net (21,1%) ou 39,13€ (10,55%), déduit des frais de Teach'r de 12,5%"
    },
    whyChooseTitle: "Pourquoi choisir Teach'r ?",
    whyChooseDescription: "Teach'r est l'un des rares services vous offrant un accès à l'Avance Immédiate en tat qu'indépendant pour vos cours sans aucune démarche administrative à réaliser. Nous vous permettons d'accéder à l'Avance Immédiate dans des délais imbattables, tout en proposant les frais de gestion les plus bas du marché !",
    advantagesTitle: "Les Avantages de Teach'r :",
    billingTitle: "Découvrez comment fonctionne la facturation avec Teach'r :",
    billingDescription: "Simplifiez votre gestion administrative avec Teach'r. De la création de votre statut d'auto-entrepreneur à la transmission des paiements, en passant par la génération et l'envoi des factures, nous prenons tout en charge. Vous n'avez plus à vous soucier de rien. Découvrez comment Teach'r peut transformer votre quotidien en comparant votre situation actuelle avec notre offre.",
    currentSituationImage: "../../Assets/Images/SchemaFacturation/SchemaCESU.png",
    teachrImage: schemaTeachr
  },
  ppnd: {
    metaDescription: "Auto-etrepreneur crédit d'impôt",
    tiktokPixelId: "CPG27CRC77UFVACF198G",
    facebookPixelId: "1126401578613360",
    heroTitle: "Professeur particulier ?",
    heroSubtitle: "Déclarez vos cours pour augmenter votre chiffre d'affaires !",
    heroDescription: "Saviez-vous qu'en tant que professeur particulier déclaré, vous exercez l'un des rares métiers en France où être déclaré vous permet de gagner davantage que sans l'être ?",
    heroButtonText: "JE M'INSCRIS !",
    heroButtonLink: `/${getActiveBrandConfig()}/register`,
    leftColumnTitle: "Non déclarés",
    rightColumnTitle: "Avec notre service, l'avance immédiate pour les professeurs indépendants",
    bottomRowData: {
      left: "Montant net perçu pour un cours payé 25€/h par votre élève, avec / sans crédit d'impôt",
      middle: "25€ payés / Rémunéré 25€",
      right: "Coût élève : 25€ après crédit d'impôt instantané. Rémunération 34,51€ net (21,1%) ou 39,13€ (10,55%), déduit des frais de Teach'r de 12,5%"
    },
    whyChooseTitle: "Pourquoi choisir Teach'r ?",
    whyChooseDescription: "Teach'r est l'un des rares services vous offrant un accès à l'Avance Immédiate pour vos cours sans aucune démarche administrative à réaliser. Nous vous permettons d'accéder à l'Avance Immédiate dans des délais imbattables, tout en proposant les frais de gestion les plus bas du marché !",
    advantagesTitle: "Les Avantages de Teach'r :",
    billingTitle: "Découvrez comment fonctionne la facturation avec Teach'r :",
    billingDescription: "De la création de votre statut d'auto-entrepreneur à la transmission des paiements, en passant par la génération et l'envoi des factures, nous prenons tout en charge. Vous n'avez plus à vous soucier de rien. Découvrez comment Teach'r peut transformer votre quotidien en comparant votre situation actuelle - où l'élève vous règle par exemple 50€ en direct - avec celle que Teach'r vous propose, en prenant l'exemple d'un cours facturé 100€ à votre élève.",
    currentSituationImage: "../../Assets/Images/SchemaFacturation/SchemaPpnd.png",
    teachrImage: schemaTeachr
  },
  guitar : {
    metaDescription: "Cours de guitare - Avance Immédiate Teach'r",
    tiktokPixelId: "CPG_GUITAR_PIXEL_ID",
    facebookPixelId: "GUITAR_FACEBOOK_PIXEL_ID",
    heroTitle: "Vous donnez des cours de guitare ?",
    heroSubtitle: "Augmentez votre chiffre d'affaires grâce à l'Avance Immédiate via Teach'r !",
    heroDescription: "Que vous soyez intermittent du spectacle, salarié ou indépendant, grâce à Teach'r, bénéficiez dès aujourd'hui de l'Avance Immédiate du crédit d'impôt. L'État prend instantanément en charge la moitié du prix de vos cours.",
    heroButtonText: "JE M'INSCRIS !",
    heroButtonLink: `/${getActiveBrandConfig()}/register`,
    heroImage: GuitareImage,
    leftColumnTitle: "Avec le CESU +",
    rightColumnTitle: "Avec notre service, l'avance immédiate pour les professeurs indépendants",
    bottomRowData: {
      left: "Montant net perçu pour un cours payé 25€/h par votre élève, avec / sans crédit d'impôt",
      middle: "25€ payés par votre élève après crédit d'impôt instantané / Rémunéré 28€ net",
      right: "Coût élève : 25€ après crédit d'impôt instantané. Rémunération 34,51€ net (21,1%) ou 39,13€ (10,55%), déduit des frais de Teach'r de 12,5%"
    },
    whyChooseTitle: "Pourquoi déclarer vos cours avec Teach'r ?",
    whyChooseDescription: "Aujourd'hui, chez Teach'r, nous comptons plus de 250 professeurs de guitare dans toute la France, tous satisfaits de la qualité de notre service. Teach'r, c'est l'accès instantané à l'Avance Immédiate : un moyen de paiement avantageux, puisque les élèves ne paient plus que 50% du prix du cours. Les professeurs peuvent ainsi être mieux rémunérés. Nos équipes se chargent de toute la partie administrative : vous n'avez qu'à renseigner vos cours sur notre plateforme et recevoir vos paiements au début du mois suivant.",
    advantagesTitle: "Les Avantages de Teach'r :",
    billingTitle: "Découvrez comment fonctionne la facturation avec Teach'r :",
    billingDescription: "Simplifiez votre gestion administrative avec Teach'r. De la création de votre statut d'auto-entrepreneur à la transmission des paiements, en passant par la génération et l'envoi des factures, nous prenons tout en charge. Vous n'avez plus à vous soucier de rien. Découvrez comment Teach'r peut transformer votre quotidien en comparant votre situation actuelle avec notre offre.",
    currentSituationImage: schemaTeachr,
    teachrImage: schemaTeachr
  }
}; 